import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { translator} from '@softline/ui-core';
import { ItemDetail } from '../../../types/item-detail';

import { IconComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-price-list',
  imports: [CdkAccordionModule, CommonModule, CurrencyPipe, DecimalPipe,
    IconComponent,
    TranslatePipe],
  templateUrl: './price-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush })
export class PriceList {
  private readonly t = translator();
  data = input.required<Partial<ItemDetail | null>>();
}
